<span [attr.id]="id ? id + '-range' : null" class="page-range">{{ pageRange }}</span>
<a
  [attr.id]="id ? id + '-prior-btn' : null"
  data-testid="prior-button"
  title="Anterior"
  i18n-title="@@prior"
  [ngClass]="{ 'disabled-link': isPriorButtonDisabled() }"
  (click)="handleChangePage('prior')"
>
  ❮
</a>
<a
  [attr.id]="id ? id + '-next-btn' : null"
  data-testid="next-button"
  title="Siguiente"
  i18n-title="@@next"
  [ngClass]="{ 'disabled-link': isNextButtonDisabled() }"
  (click)="handleChangePage('next')"
>
  ❯
</a>
